import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';
import COLORS from '../../styles/emotion/colors3';

const fadeOut = keyframes`
  0% {opacity:0}
  50%  {opacity: 1}
  100% {opacity: 0}
`;

const slideRight = keyframes`
  10% {left: 0}
  50% {left: 50px}
  100% {left: 50px}
`;

const slideLeft = keyframes`
  10% {right: 0}
  50% {right: 50px}
  100% {right: 50px}
`;

export const Container = styled.div<{ iterationCount: string | number }>`
  display: flex;
  animation: ${fadeOut} 1.5s linear ${({ iterationCount }) => iterationCount};
`;

export const HeartWrapper = styled.div`
  position: relative;
  width: 81px;
  height: 36px;
  svg {
    color: ${COLORS.COVE_100};
  }
`;

export const LeftHeart = styled.div<{ iterationCount: string | number }>`
  position: absolute;
  left: 0;
  animation: ${slideRight} 1.5s linear ${({ iterationCount }) => iterationCount};
`;

export const RightHeart = styled.div<{ iterationCount: string | number }>`
  position: absolute;
  right: 0;
  animation: ${slideLeft} 1.5s linear ${({ iterationCount }) => iterationCount};
`;
